import React from 'react';
import { Box, AppBar, Toolbar } from '@mui/material';
import svgSrc from 'assets/images/logo.svg';
import { useIsMobile } from '../../../shared/hooks';

export const Layout = (props: React.PropsWithChildren<object>) => {
  const { children } = props;
  const isMobile = useIsMobile();
  return (
    <Box>
      <AppBar
        component="nav"
        sx={{
          backgroundColor: '#262B2D',
          position: 'relative',
          boxShadow: 'none',
          height: '56px',
        }}
      >
        <Toolbar
          sx={{
            paddingLeft: '16px !important',
            paddingRight: '16px !important',
            minHeight: '56px !important',
          }}
        >
          <Box
            component={'img'}
            sx={{
              width: '110px',
            }}
            alt="NewtonX_logo"
            src={svgSrc}
          ></Box>
        </Toolbar>
      </AppBar>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          paddingTop: isMobile ? '32px' : '64px',
          paddingLeft: '16px',
          paddingRight: '16px',
          paddingBottom: isMobile ? '32px' : '64px',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
